import { heroBadges } from "@/mocks/civicData";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-[640px] w-full items-center overflow-hidden bg-foreground-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20sunrise%20over%20a%20peaceful%20beijing%20hutong%20neighborhood%20in%20the%20morning%20golden%20ambient%20light%2C%20soft%20fog%20above%20traditional%20grey%20tile%20rooftops%2C%20gentle%20warm%20vermilion%20and%20amber%20tones%2C%20community%20and%20harmony%20atmosphere%2C%20editorial%20documentary%20photography%2C%20quiet%20trustworthy%20civic%20mood&width=1920&height=900&seq=hero-cy-qunzhong-2026&orientation=landscape"
          alt="清晨阳光下的北京胡同社区，象征和谐安宁的共治家园"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-24 md:px-6">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-black/20 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur-sm">
            <i className="ri-sun-fill text-accent-300"></i>
            朝阳群众 · 群防群治在线指引
          </p>

          <h1 className="speakable mt-6 font-heading text-4xl font-bold leading-tight text-background-50 md:text-6xl">
            人人都是平安家园的
            <span className="text-accent-300">守望者</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-8 text-background-100/90 md:text-lg md:leading-9">
            这里为你汇总反映问题、提供线索的正规渠道与信息提交指南。依法、客观、理性地把身边情况反映给相关部门，配合核查处理，让问题得到及时关注——一个负责任的线索指南，从这里开始。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#guide"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-400"
            >
              查看信息指南
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#channels"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-base font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              了解反映渠道
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap gap-2.5">
            {heroBadges.map((b) => (
              <li
                key={b}
                className="rounded-full bg-black/25 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm"
              >
                {b}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <a
        href="#about"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 z-10 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full text-background-50/80 hover:text-background-50"
      >
        <i className="ri-arrow-down-s-line text-2xl"></i>
      </a>
    </section>
  );
}